import type { ViewerKind } from "@/lib/api";
import { viewerKindLabel, viewerKindTitle } from "@/lib/format";

interface ViewerKindBadgeProps {
  kind: ViewerKind;
  /** O viewer foi escolhido à mão no gerenciador, e não pela triagem. */
  manual?: boolean;
}

const CLASS_BY_KIND: Record<ViewerKind, string> = {
  document: "bg-sky-900/60 text-sky-300 ring-1 ring-sky-700/50",
  packaging: "bg-orange-900/60 text-orange-300 ring-1 ring-orange-700/50",
};

/**
 * Qual viewer o arquivo abre — `Doc` ou `Package` — ao lado do selo de formato.
 *
 * O formato diz o que o arquivo é; este selo diz para onde o «Abrir» leva. Os
 * dois viewers têm ferramentas diferentes, e o operador escolhe o que abrir
 * pela lista, sem ter de abrir para descobrir.
 *
 * O lápis marca a escolha feita à mão (29/09/2026): sem ele, um arquivo que a
 * triagem erraria e alguém corrigiu parece igual a um que a triagem acertou, e
 * ninguém saberia por que ele não segue a regra dos vizinhos.
 */
export function ViewerKindBadge({ kind, manual = false }: ViewerKindBadgeProps) {
  return (
    <span
      className={`rounded px-1.5 py-0.5 text-[10px] font-medium ${CLASS_BY_KIND[kind]}`}
      title={manual ? `${viewerKindTitle(kind)} — escolhido à mão no gerenciador` : viewerKindTitle(kind)}
    >
      {viewerKindLabel(kind)}
      {manual ? <span aria-label="escolhido à mão"> ✎</span> : null}
    </span>
  );
}
